
<template>
    <div class="row">
        <div class="col-md-12">
            <b-row>
                <b-col>
                    <h2>Relatório PDV</h2>
                </b-col>
            </b-row>
            <b-row align-v="end" class="mt-3">
                <b-col>
                    <label>Data Início</label>
                    <date-picker v-model="fromDate" :config="datePickerConfig"></date-picker>
                </b-col>
                <b-col>
                    <label>Data Fim</label>
                    <date-picker v-model="toDate" :config="datePickerConfig"></date-picker>
                </b-col>
                <b-col>
                    <label>Tipo de Relatório</label>
                    <select v-model="tipo" class="form-control">
                        <option> Selecione um tipo</option>
                        <option value="A">Analítico</option>
                        <option value="S">Sintético</option>
                    </select>
                </b-col>
                <b-col>
                    <b-button variant="primary" @click="geraRelatorio()">
                        Gerar
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    props: [],
    data() {
        return {
            datePickerConfig: {
                'format': 'D/MM/YYYY',
                'showClose': true
            },
            fromDate: "",
            tipo: '',
            toDate: "",
            dateDisabled: {
                from: new Date()
            },
        }
    },
    methods: {
        initDates() {
            let m = moment();
            m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            this.toDate = moment();
            this.toDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            this.fromDate = m;
            this.fromDate.subtract(1, 'month');

        },
        geraRelatorio() {
            var vm = this;
            if (this.tipo === '') {
                return this.$swal('Atenção', 'Informe um tipo de relatório', 'error');
            }
            this.$swal.fire({
                title: 'Selecione o formato do relatório.',
                input: 'select',
                inputOptions: {
                    'EXCEL': 'Excel',
                    'PDF': 'PDF',
                },
                inputPlaceholder: 'Informe o tipo de arquivo ',
                showCancelButton: true,
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (vm.tipo === 'A') {
                            this.getLoadAnalitico(value);
                            return resolve();
                        } else if (vm.tipo === 'S') {
                            this.getLoadSintetico(value);
                            return resolve();
                        } else {
                            return resolve('Informe um tipo de relatório a ser gerado.');
                        }

                    })
                }
            });
        },
        getLoadSintetico(type) {
            var vm = this;
            if (vm.fromDate === '' || vm.fromDate === null) {
                return vm.$swal('Ops', 'Informe uma data de início', 'error');
            }
            $('.loading').show();
            axios({
                url: '/distribuidor/pdv/relatorio/sintetico',
                method: 'GET',
                responseType: 'blob',
                params: {
                    from: vm.fromDate,
                    to: vm.toDate,
                    type: type
                }
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio-sintetico.pdf');
                document.body.appendChild(link);
                link.click();
                $('.loading').hide();
            })

        },
        getLoadAnalitico(type) {
            var vm = this;
            if (vm.fromDate === '' || vm.fromDate === null) {
                return vm.$swal('Ops', 'Informe uma data de início', 'error');
            }
            $('.loading').show();
            axios({
                url: '/distribuidor/pdv/relatorio/analitico',
                method: 'GET',
                responseType: 'blob',
                params: {
                    from: vm.fromDate,
                    to: vm.toDate,
                    type: type
                }
            }).then((response) => {

                const blob = new Blob([response.data], { type: response.data.type });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'unknown';
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                    if (fileNameMatch.length === 2)
                        fileName = fileNameMatch[1];
                }
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                $('.loading').hide();
            })

        }



    },
    computed: {

    },
    created() {

        this.status = $("#status").val();
    },
    mounted() {
        // this.initDates()

    }
}

</script>

<style scoped="">
.label-status {
    font-size: 1.2em;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/relatorio/PDV.vue